// extracted by mini-css-extract-plugin
export default {"LanguageCircleIndicator":"LanguageCircle-module__LanguageCircleIndicator__GgHY6Sz"};